export default [
    {
        "year": 1985,
        "question": "如果正方体ABCD-A'B'C'D'的棱长为a，那么四面体A'-ABD的体积是",
        "A": "a3/2",
        "B": "a3/3",
        "C": "a3/4",
        "D": "a3/6",
        "answer": "D"
    },
    {
        "year": 1986,
        "question": "设甲是乙的充分条件,乙是丙的充要条件,丙是丁的必要条件,那么丁是甲的",
        "A": "充分条件",
        "B": "必要条件",
        "C": "充要条件",
        "D": "既不充分也不必要条件",
        "answer": "D"
    },
    {
        "year": 1987,
        "question": "下列长度的三条线段能构成三角形的是（ ）",
        "A": "3,4,8",
        "B": "3,4,7",
        "C": "5,6,10",
        "D": "5,6,11",
        "answer": "C"
    },
    {
        "year": 1988,
        "question": "设圆M的方程为（x-3）2+（y-2）2=2，直线L的方程为x+y-3=0，点P的坐标为（2，1），那么（ ）",
        "A": "点P在直线L上，但不在圆M上",
        "B": "点P在圆M上，但不在直线L上",
        "C": "点P既在圆M上，又在直线L上",
        "D": "点P既不在直线L上，也不在圆M上",
        "answer": "C"
    },
    {
        "year": 1989,
        "question": "由数字1，2,3,4,5组成没有重复数字的五位数，其中偶数共有( )",
        "A": "60个",
        "B": "48个",
        "C": "36个",
        "D": "24个",
        "answer": "B"
    },
    {
        "year": 1990,
        "question": "方程200-x=195的解是（ ）",
        "A": "x=395",
        "B": "x=195",
        "C": "x=95",
        "D": "x=5",
        "answer": "D"
    },
    {
        "year": 1991,
        "question": "点P（2，5）关于直线x+y=0的对称点的坐标是",
        "A": "（5，2）",
        "B": "（2，-5）",
        "C": "（5，-2）",
        "D": "（-2，-5）",
        "answer": "C"
    },
    {
        "year": 1992,
        "question": "在四棱锥的四个侧面中，直角三角形最多可有（  ）",
        "A": "1个",
        "B": "2个",
        "C": "3个",
        "D": "4个",
        "answer": "D"
    },
    {
        "year": 1993,
        "question": "函数f（x）=sinx+cosx的最小正周期是（ ）",
        "A": "2π",
        "B": "22π",
        "C": "π",
        "D": "π/4",
        "answer": "A"
    },
    {
        "year": 1994,
        "question": "已知正六棱台的上，下底面边长分别为 2和4，高为2，则其体积为( )",
        "A": "32√3",
        "B": "28√3",
        "C": "24√3",
        "D": "20√3",
        "answer": "A"
    },
    {
        "year": 1995,
        "question": "已知集合I={0，﹣1，﹣2，﹣3，﹣4}，集合M={0，﹣1，﹣2}，N={0，﹣3，﹣4}，则M∩N=（  ）",
        "A": "{0}",
        "B": "{﹣3，﹣4}",
        "C": "{﹣1，﹣2}",
        "D": "φ",
        "answer": "A"
    },
    {
        "year": 1996,
        "question": "六名同学排成一排，其中甲、乙两人必须排在一起的不同排法有（）",
        "A": "720种",
        "B": "360种",
        "C": "240种",
        "D": "120种",
        "answer": "C"
    },
    {
        "year": 1997,
        "question": "设集合M=[x0≤x<2），集合N=x|x2-2x-3<0），集合M∩N=（ ）",
        "A": "{x|0≤x<1}",
        "B": "{x|0≤x<2}",
        "C": "{x|0≤x≤1}",
        "D": "{x|0≤x≤2}",
        "answer": "B"
    },
    {
        "year": 1998,
        "question": "已知圆锥的全面积是底面积的3倍,那么该圆锥的侧面积展开图扇形的圆心角为（ ）",
        "A": "120°",
        "B": "150°",
        "C": "180°",
        "D": "240°",
        "answer": "C"
    },
    {
        "year": 1999,
        "question": "若f (x) sinx是周期为π的奇函数, 则f (x)可以是（ ）",
        "A": "sinx",
        "B": "cosx",
        "C": "sin2x",
        "D": "cos2x",
        "answer": "B"
    },
    {
        "year": 2000,
        "question": "一个长方体共一顶点的三个面的面积分别是√2，√3，√6，这个长方体对角线的长是(  )",
        "A": "2√3",
        "B": "3√2",
        "C": "6",
        "D": "√6",
        "answer": "D"
    },
    {
        "year": 2001,
        "question": "若一个圆锥的轴截面是等边三角形,其面积为3，则这个圆锥的全面积是（ ）",
        "A": "3π",
        "B": "3√3π",
        "C": "6π",
        "D": "9π",
        "answer": "A"
    },
    {
        "year": 2002,
        "question": "直线（1+a）x+y+1=0与圆x+y-2x=0相切，则a的值为（ ）",
        "A": "1,-1",
        "B": "2.-2",
        "C": "1",
        "D": "-1",
        "answer": "D"
    },
    {
        "year": 2003,
        "question": "直线y=2x关于x对称的直线方程为（ ）",
        "A": "y=-1/2X",
        "B": "y=1/2X",
        "C": "y=-2x",
        "D": "y=2x",
        "answer": "C"
    },
    {
        "year": 2004,
        "question": "4名教师分配到3所中学任教，每所中学至少1名教师，则不同的分配方案共有( )",
        "A": "12种",
        "B": "24种",
        "C": "36种",
        "D": "48种",
        "answer": "C"
    },
    {
        "year": 2005,
        "question": "一个与球心距离为1的平面截球所得的圆面面积为π，则球的表面积为（ ）",
        "A": "8√2π",
        "B": "8π",
        "C": "4√2π",
        "D": "4π",
        "answer": "B"
    },
    {
        "year": 2006,
        "question": "如果函数y=f(x)的图像与函数y=3-2x的图像关于原点对称，则y=f(x)的表达式为",
        "A": "y=2x-3",
        "B": "y=2x+3",
        "C": "y=-2x+3",
        "D": "y=-2x-3",
        "answer": "D"
    },
    {
        "year": 2007,
        "question": "设S=（x|2x+1>0T，T=fx|3x-5<0），则SnT=（ ）",
        "A": "O",
        "B": "{x|x<-1/2}",
        "C": "{x|xD＞2}",
        "D": "{x|-1/2<x<5/3}",
        "answer": "D"
    },
    {
        "year": 2008,
        "question": "掷一个骰子，向上一面的点数大于2且小于5的概率为p1，抛两枚硬币,正面均朝上的概率为p2,则（ ）",
        "A": "p1<p2",
        "B": "p1>p2",
        "C": "p1=p2",
        "D": "不能确定",
        "answer": "B"
    },
    {
        "year": 2009,
        "question": "已知a，β表示两个不同的平面，m为平面a内的一条直线，则“a⊥β”是“m⊥β”的（ ）",
        "A": "充分不必要条件",
        "B": "必要不充分条件",
        "C": "充要条件",
        "D": "既不充分也不必要条件",
        "answer": "B"
    },
    {
        "year": 2010,
        "question": "曲线y=x*2-2x+1在点(1,0)处的切线方程为",
        "A": "y=x-1",
        "B": "y=-x+1",
        "C": "y=2x-2",
        "D": "y=-2x+2",
        "answer": "A"
    },
    {
        "year": 2011,
        "question": "已知集合M=tO，1,2,3,4）,N=f1，3，5，P=MnN，则P的子集共有（ ）",
        "A": "2个",
        "B": "4个",
        "C": "6个",
        "D": "8个",
        "answer": "B"
    },
    {
        "year": 2012,
        "question": "平面a截球O的球面所得圆的半径为1,球心O到平面a的距离为√2，则此球的体积为（ ）",
        "A": "√6π",
        "B": "4√3π",
        "C": "4√6π",
        "D": "6√3π",
        "answer": "B"
    },
    {
        "year": 2013,
        "question": "从1,2,3,4中任取2个不同的数，则取出的2个数之差的绝对值为2的概率是（ ）",
        "A": "二分之一",
        "B": "三分之一",
        "C": "四分之一",
        "D": "六分之一",
        "answer": "B"
    },
    {
        "year": 2014,
        "question": "已知集合M={x1-1<x<3},N={x1-2<x<1}，则MnN=（ ）",
        "A": "（-2,1）",
        "B": "（-1,1）",
        "C": "（1,3）",
        "D": "（-2,3）",
        "answer": "B"
    },
    {
        "year": 2015,
        "question": "圆心为(1,1)且过原点的圆的方程是（ ）",
        "A": "(x-1)²+(y-1)=1",
        "B": "(x+1)²+(y+1)=1",
        "C": "(x+1)²+(y+1)=2",
        "D": "(x-1)²+(y-1)=2",
        "answer": "D"
    },
    {
        "year": 2016,
        "question": "已知A（2，5），B（4，1）.若点P（x，y）在线段AB上，则2x−y的最大值为（ ）",
        "A": "-1",
        "B": "3",
        "C": "7",
        "D": "8",
        "answer": "C"
    },
    {
        "year": 2017,
        "question": "若复数(1-i)(α+i)在复平面内对应的点在第二象限，则实数α的取值范围是(  )",
        "A": "（-∞,1)",
        "B": "（-∞,-1)",
        "C": "（1,+∞)",
        "D": "（-1,+∞)",
        "answer": "B"
    },
    {
        "year": 2018,
        "question": "设a,b,c,d是非零实数，则“ad=bc”是“a,b,c,d成等比数列”的（ ）",
        "A": "充分而不必要条件",
        "B": "必要而不充分条件",
        "C": "充分必要条件",
        "D": "既不充分也不必要条件",
        "answer": "B"
    },
    {
        "year": 2019,
        "question": "设函数f（x）=cosx+bsinx（b为常数），则“b=0”是“f（x）为偶函数”的（ ）",
        "A": "充分而不不要条件",
        "B": "必要而不充分条件",
        "C": "充分必要条件",
        "D": "既不充分也不必要条件",
        "answer": "C"
    },
    {
        "year": 2020,
        "question": "已知半径为1的圆经过点(3,4)，则其圆心到原点的距离的最小值为（ ）",
        "A": "4",
        "B": "5",
        "C": "6",
        "D": "7",
        "answer": "A"
    }
]